var InteractiveVariants;
(function (InteractiveVariants) {
    InteractiveVariants["INTERACTIVE_SUCCESS"] = "interactiveSuccess";
    InteractiveVariants["INTERACTIVE_ERROR"] = "interactiveError";
    InteractiveVariants["INTERACTIVE_WARNING"] = "interactiveWarning";
    InteractiveVariants["INTERACTIVE_INFORMATION"] = "interactiveInformation";
})(InteractiveVariants || (InteractiveVariants = {}));
var PassiveVariants;
(function (PassiveVariants) {
    PassiveVariants["PASSIVE_SUCCESS"] = "passiveSuccess";
    PassiveVariants["PASSIVE_ERROR"] = "passiveError";
    PassiveVariants["PASSIVE_WARNING"] = "passiveWarning";
    PassiveVariants["PASSIVE_INFORMATION"] = "passiveInformation";
})(PassiveVariants || (PassiveVariants = {}));
var SubheaderVariants;
(function (SubheaderVariants) {
    SubheaderVariants["SUBHEADER_SUCCESS"] = "subheaderSuccess";
    SubheaderVariants["SUBHEADER_ERROR"] = "subheaderError";
})(SubheaderVariants || (SubheaderVariants = {}));
export { InteractiveVariants, PassiveVariants, SubheaderVariants, };
//# sourceMappingURL=Notification.types.js.map